import { render, staticRenderFns } from "./InfiniteScrollTables.vue?vue&type=template&id=721875be"
import script from "./InfiniteScrollTables.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports